import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { Suspense, lazy } from "react";

const SubscriptionTabs = lazy(() => import("./tabs"));

const SubscriptionTabsLazy = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <SubscriptionTabs />
    </Suspense>
  );
};

export default SubscriptionTabsLazy;
